.status-label-wrapper {
  height: 24px;
}
